export default __webpack_public_path__ + "media/images/coworkr/favicons/icon76-ec618222c7dd9492b5ff15ab69800228.png";